import React, { Component } from 'react'
import { css, GridCell, Spinner, Grid, Icon, Theme, TextInput } from "@bdfx/mergado-ui-kit"
import trans from "trans"
import { projectId, saveFilterAsQuery } from "app/helpers/api";
import { FiltersFormType } from "../types/filtertypes";
import ParseFiltersForm from "./parse-filters-form";
import { ViewTableType } from "../containers";
import { FIEQueryType } from "./fie-queries";
import { setFIEQueriesToStore } from 'products/reducer';

export interface Props {
    filtersForm: FiltersFormType
    hideModal: Function
    viewTable: ViewTableType
    setFIEQueriesToStore: typeof setFIEQueriesToStore
}

interface State {
    queryName: string
    queryElement: string
    isSaving: boolean
    validate: boolean
}

export const elementPrefix = 'FIE_QUERY_'

class SaveAsQueryModalWrapper extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            queryName: null,
            queryElement: null,
            isSaving: false,
            validate: false,
        }
    }

    render() {
        const { filtersForm, viewTable } = this.props
        const { queryName, queryElement, isSaving, validate } = this.state

        const isDisabled = isSaving || !queryName || !queryElement

        const fieQuery: FIEQueryType = {
            is_active: 1,
            project_id: projectId,
            name: queryName,
            element: queryElement,
            viewtable: viewTable,
            filter: JSON.stringify(filtersForm),
        }

        return (
            <div>
                <StyledMainGrid>
                    <GridCell className={'formFIEQuery'}>
                        <StyledGrid>
                            <GridCell>{trans('fie_query_name')}</GridCell>
                            <GridCell>
                                <TextInput
                                    value={queryName}
                                    onChange={(e) => {
                                        const noSpecialCharacters = e.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9 \-_]/g, '').replace(/[ \-]/g, '_').toUpperCase()
                                        this.setState({
                                            queryName: e,
                                            queryElement: `${noSpecialCharacters}`
                                        })
                                    }}
                                    error={(validate && !queryName) ? trans('not_empty_error') : null}
                                    placeholder={trans('fie_query_name')}
                                />
                            </GridCell>

                            <GridCell>{trans('fie_query_element')} {elementPrefix}</GridCell>
                            <GridCell>
                                <TextInput
                                    disabled={true}
                                    value={queryElement}
                                    error={(validate && !queryElement) ? trans('not_empty_error') : null}
                                    onChange={(e) => this.setState({ queryElement: e.replace(elementPrefix, '') })}
                                />
                            </GridCell>
                        </StyledGrid>
                    </GridCell>

                    <GridCell className={'info'}>
                        <ParseFiltersForm fieQuery={fieQuery} isEditMode={false} />
                    </GridCell>
                </StyledMainGrid>

                {isSaving ?
                    <Spinner type={'bubbles'} />
                    :
                    <div style={{ margin: '20px 0' }}>
                        <StyledButton
                            style={{
                                opacity: isDisabled ? .4 : 1
                            }}
                            onClick={() => {
                                this.setState({ validate: true })
                                if (!isDisabled) {
                                    this.setState({ isSaving: true })
                                    saveFilterAsQuery(filtersForm, queryName, queryElement, this.props.viewTable)
                                        .then((response: any) => {
                                            this.props.setFIEQueriesToStore(response.data)
                                        })
                                        .catch(error => {
                                            console.error('cannot save', error.response)
                                        })
                                        .finally(() => {
                                            this.setState({ isSaving: false })
                                            this.props.hideModal()
                                        })
                                }
                            }}
                        >
                            <Icon type={'save-light'} text={trans('save')} color={'#fff'} />
                        </StyledButton>
                    </div>
                }
            </div>
        )
    }
}

const StyledMainGrid = css(Grid)({
    gridTemplateColumns: '50% 50%',
    gridGap: '20px',
})

const StyledGrid = css(Grid)({
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: '20px',
    ' .muk-gridcell': {
        alignSelf: 'center',
        lineHeight: '30px',
        marginBottom: '10px',
    }
})

const StyledButton = css('span')({
    background: Theme.blue,
    color: '#fff',
    padding: 10,
    cursor: 'pointer',
    borderRadius: Theme.radius,
    fontWeight: 'bold',
})


export default SaveAsQueryModalWrapper
